export const money = (value, currency = "TRY") =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency, maximumFractionDigits: 0 }).format(value || 0);

export const tryValue = (tx, fallbackRate = 0) => {
  if (tx.currency_rate) return tx.amount * tx.currency_rate;
  if (tx.currency === "TRY") return tx.amount;
  return tx.amount * (tx.rate || fallbackRate || 1);
};

export const allocationsOf = c =>
  c.allocations?.length ? c.allocations : (c.account ? [{ account: c.account, amount: c.amount }] : []);

export const accountShareTry = (c, account, fallbackRate = 0) => {
  const allocs = allocationsOf(c);
  if (!allocs.length || !c.amount) return 0;
  const mine = allocs.filter(a => a.account === account).reduce((sum, a) => sum + a.amount, 0);
  return tryValue(c, fallbackRate) * (mine / c.amount);
};

export const today = () => new Date().toISOString().slice(0, 10);
export const currentMonth = () => new Date().toISOString().slice(0, 7);
